<script setup>
import {reactive, provide} from "vue";
import SideBarUpdates from "@/views/trackers/tracker/SideBarUpdates.vue";

const filters = reactive({
    'added-task': true,
    'removed-task': true,
    'updated-task': true,
    'changed-task-status': true,
    'notes': true,
});

const trackerUpdatesFilters = [
    'notes',
    'added-task',
    'removed-task',
    'updated-task',
    'changed-task-status',
];

provide('filters', filters);
provide('trackerUpdatesFilters', trackerUpdatesFilters);
</script>

<template>
    <SideBarUpdates/>
</template>

<style scoped>

</style>
